import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'react-bootstrap';
import Moment from 'react-moment';
import * as moment from 'moment';

import { deepEqual } from './../../utils';

import './styles.css';

class VehicleLastPosition extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  status() {
    const { ignition, speed, time } = this.props.lastPosition;
    if (moment().subtract(1, 'hour').isAfter(time)) { return 'outdated'; }
    if (!ignition) { return 'parked'; }
    if (ignition && speed <= 3) { return 'waiting'; }
    return '';
  }

  labelStyle() {
    switch (this.status()) {
      case 'outdated': return 'default';
      case 'parked': return 'danger';
      case 'waiting': return 'warning';
      default: return 'success';
    }
  }

  render() {
    const { lastPosition } = this.props;
    return (!lastPosition.time
      ? (
        <div className="last-position-wrapper">
          <div className="primary">
            <small>Sem informações do Rastreador</small>
          </div>
        </div>
      ) : (
        <div className="last-position-wrapper">
          <div className="primary">
            <small>
              <Label bsStyle={this.labelStyle()}>{lastPosition.speed} km/h</Label>
              {'  '}
              <Moment fromNow>
                {lastPosition.time}
              </Moment>
              {'  '}
              <small>
                {'('}
                <Moment format="DD/MM HH:mm">{lastPosition.time}</Moment>
                {')'}
              </small>
            </small>
          </div>
          {lastPosition.detail && <div className="secondary">{lastPosition.detail}</div>}
          <div className="secondary">
            {lastPosition.city}
          </div>
          {/* <div className="secondary">
            <small>
              <Label bsStyle="default">estacionado</Label> desde 10 horas
            </small>
          </div> */}
        </div>
      ));
  }
}

VehicleLastPosition.propTypes = {
  lastPosition: PropTypes.object.isRequired,
};

export default VehicleLastPosition;



// WEBPACK FOOTER //
// ./src/Vehicle/VehicleLastPosition/index.js